'use client';

import * as SwitchPrimitives from '@radix-ui/react-switch';
import * as React from 'react';

import { cn } from '@/lib/utils';

const Switch = React.forwardRef(({ className, ...props }, ref) => (
  <SwitchPrimitives.Root
    className={cn(
      'focus-visible_ring-ring focus-visible_ring-offset-background peer inline-flex h-6 w-12 shrink-0 cursor-pointer items-center rounded-full border-2 border-primary bg-white transition-colors focus-visible_outline-none focus-visible_ring-2 focus-visible_ring-offset-2 disabled_cursor-not-allowed disabled_opacity-50 data-[state=unchecked]_border-[#929292]',
      className,
    )}
    {...props}
    ref={ref}
  >
    <SwitchPrimitives.Thumb
      className={cn(
        'pointer-events-none block h-4 w-4 rounded-full shadow-lg ring-0 transition-transform data-[state=checked]_translate-x-6 data-[state=unchecked]_translate-x-1 data-[state=checked]_bg-black data-[state=unchecked]_bg-[#929292]',
      )}
    />
  </SwitchPrimitives.Root>
));

Switch.displayName = SwitchPrimitives.Root.displayName;

export { Switch };
